// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1AvCN","title":"AfterFrontImage_title__3751X"};